var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a202c",
    stroke: "#1a202c",
    strokeWidth: 0.75,
    d: "M16.89.328l8.044 2.475c.252.078.438.334.435.599v17.95c0 .385-.434.705-.803.59l-7.86-2.417-7.86 2.417c-.118.037-.249.037-.367 0L.435 19.467c-.25-.078-.435-.329-.435-.59V.927c-.005-.39.432-.715.803-.6l7.86 2.418 7.86-2.417c.131-.044.281-.015.367 0h0zm.435 1.44v16.645l6.806 2.088V3.856l-6.806-2.088zm-1.237 0L9.28 3.856v16.645l6.807-2.088V1.768zm-14.85 0v16.645L8.044 20.5V3.856L1.238 1.768z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c6bfc294.svg";
export { ForwardRef as ReactComponent };